
<div class="loader_session" *ngIf='loaderdata'>
    <div class="loader-4"><span></span>
  </div>
  </div>
  
<!-- shopy Head -->
<div
  class="shopyheader"
  style="background-image: url(assets/image/Group-1766.png)"
>
  <div class="shopyheadings">
    <div class="head">
      <h3>BOARD OF DIRECTORS/ <br> ADVISORY BOARD</h3>
    </div>
  </div>
</div>


<!-- advisory heder -->

<div class="address-box">
    <div class="container">
        <div class="address-details">
            <img src="assets/image/logo.png">
            <h2><span>The Antique Phonograph Society </span><br> P.O. Box 169, Victorville, CA 92393</h2>
        </div>
    </div>
</div>
<div class="advisory-details">
    <div class="container">
        <div class="adv-details">
            <h2>The Antique Phonograph Society is an open, worldwide community of people passionate about gramophones, phonographs, cylinder and disc records, and related items.<br> We welcome questions and comments from those seeking information, identification, repair assistance, and guidance with machines and records.</h2>
        </div>
        <div class="adv-sub-details">
            <div class="row">
                <div class="col-md-6 border-adv">
                    <p>If you have a question about an antique phonograph (buying, selling, identification, repairs, etc.) ASK IT ON OUR FREE APS <a href target="_blank" href="https://forum.antiquephono.org/">FORUM</a>. The  <a href target="_blank" href="https://forum.antiquephono.org/">Forum</a> will put you in touch with experienced and helpful people in our community.</p>
                </div>
                <div class="col-md-6 border-adv ">
                    <p>For questions and comments about the Antique Phonograph Society (joining, assistance with online accounts, member benefits, etc.), <a  href="mailto:info@antiquephono.org">click here.</a> </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="advisory-contact">
    <div class="container">
        <div class="adv-contact-head">
            <h3>YOU MAY USE ONE OF THE FOLLOWING LINKS TO CONTACT SPECIFIC INDIVIDUALS</h3>
        </div>
        <div class="adv-contact-details">
            <!-- <div class="row">
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>President: <br> <span>John Levin</span> </h2>
                        <a class="adv-btn"  href="mailto:president@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Vice President: <br> <span>Rod Pickett</span> </h2>
                        <a class="adv-btn"  href="mailto:vice_president@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Secretary:<br> <span>Mike Sherman</span> </h2>
                        <a class="adv-btn"  href="mailto:secretary@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Treasurer: <br> <span>Jeff Oliphant</span> </h2>
                        <a class="adv-btn" href="mailto:treasurer@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Director:   <br> <span>Shawn O’Rourke</span> </h2>
                        <a class="adv-btn"  href="mailto:shawn@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Editor: <br> <span>Rene Rondeau</span> </h2>
                        <a class="adv-btn" href="mailto:editor@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>President Emeritus:<br> <span>George Paul</span> </h2>
                        <a class="adv-btn"  href="mailto:george@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>Program Director: <br> <span>John Levin </span> </h2>
                        <a class="adv-btn" href="mailto:program_director@antiquephono.org">CONTACT</a>
                    </div>
               
                </div>
            </div> -->
            <div class="row">
              
            <ng-template ngFor let-item [ngForOf]="boardmember" let-i="index">
                <div class="col-lg-3 col-md-4">
                    <div class="contact-info">
                        <h2>{{item.position}}: <br> <span>{{item.name}}</span> </h2>
                        <a class="adv-btn" href="mailto:{{item.email}}">CONTACT</a>
                    </div>
               
                </div>
         
              </ng-template>
            </div>

        </div>
        <div class="adv-board-details">
            <div class="board-element">
                <div class="board-head">
                    <h3>Advisory Board</h3>
                </div>
                <div class="board-members">
                    <ng-template ngFor let-aditem [ngForOf]="admember" let-i="index">
                        <div class="member-details">
                            <h1>{{aditem.name}}</h1>
        
                        </div>
                 
                      </ng-template>
                 <!--   <div class="member-details">
                        <h1> Bob Baumbach</h1>
                         <a class="adv-btn" href="mailto:bob_baumbach@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Gregg Cline</h1>
                        <!- <a class="adv-btn" href="mailto:gregg_cline@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Charley Hummel</h1>
                        <!- <a class="adv-btn" href="mailto:charley_hummel@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Anil Menon</h1>
                        <!- <a class="adv-btn" href="mailto:anil_menon@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Shawn O’Rourke</h1>
                        <-- <a class="adv-btn" href="mailto:shawn_orourke@antiquephono.org">CONTACT</a>->
                    </div>
                    <div class="member-details">
                        <h1> Jeff Oliphant</h1>
                        <!- <a class="adv-btn" href="mailto:treasurer@antiquephono.org">CONTACT</a>->
                    </div>
                    <div class="member-details">
                        <h1> George Paul</h1>
                        <-- <a class="adv-btn" href="mailto:george@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Rod Pickett</h1>
                        <- <a class="adv-btn"  href="mailto:vice_president@antiquephono.org">CONTACT</a> ->
                    </div>
                    <div class="member-details">
                        <h1> Rene Rondeau</h1>
                        <!- <a class="adv-btn" href="mailto:editor@antiquephono.org">CONTACT</a> 
                    </div>-->
                </div>
                <!-- <div class="text-right mx-2 mt-5">
                   <p>For questions and comments.. <a  href="mailto:info@antiquephono.org">Click here</a></p> 
                </div> -->

            </div>
        </div>
    </div>
</div>
<!-- 
<div class="advisory-contactus">
    <div class="container">
        <div class="contact-head">
            <h3>CONTACT <span>US</span> </h3>
        </div>
        <div class="contactform">
            <form #userlogin="ngForm" (ngSubmit)="onClickSubmit(userlogin)">
                <div class="form-row">
                  <div class="col-md-6">
                    <input type="text" name=name class="form-control formcontent" [ngModel] required placeholder="NAME" #name="ngModel">
                    <div class="alertbox-err" *ngIf="name.touched && name.invalid">
                        Name Required
                    </div>
                    
                  </div>
                  <div class="col-md-6">
                    <input type="text" class="form-control formcontent"   name=location [ngModel] required  placeholder="LOCATION" #location="ngModel">
                    <div class="alertbox-err" *ngIf="location.touched && location.invalid">
                        Location Required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <input type="email" class="form-control formcontent"  name="email" [ngModel] required placeholder="EMAIL" #email="ngModel">
                    <div class="alertbox-err" *ngIf="email.touched && email.invalid">
                        Email Required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <input type="text" class="form-control formcontent" name="phone" [ngModel] required placeholder="PHONE" #phone="ngModel">
                    <div class="alertbox-err" *ngIf="email.touched && email.invalid">
                        Phone Required
                    </div>
                  </div>
                  <div class="col-12">
                    <textarea class="form-control formcontent" rows="5" id="comment"  name="message"
                    [ngModel] placeholder="MESSAGE"></textarea>
                  </div>
                  
                  <div class="btn-contents">
                     <input type="submit" class="btn-cont" value="SEND" >

                  </div>
                </div>
              </form>
        </div>
    </div>
</div> -->